<template>
  <div>
    <b-card>
      <div v-if="loading">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem"
          label="Large Spinner"
        ></b-spinner>
      </div>

      <b-row v-if="!loading">
        <b-col>
          <form-base
            title="Create Invoice"
            :submit-status="submitStatus"
            action="Create"
            :errors="errors"
            :loading="loading"
            v-on:handleSubmit="handleSubmit"
          >
            <template v-slot:fields>
              <form-group label="Select Tenant" :required="true">
                <v-select
                  label="accountable"
                  :options="accounts"
                  :filterable="false"
                  @search="getAccounts"
                  v-model="selectedAccount"
                >
                  <template slot="no-options">
                    Type to search tenant by name or contact number
                  </template>
                  <template slot="option" slot-scope="c">
                    <div v-if="c.accountable">
                      {{ c.accountable.name }} {{ c.accountable.surname }} -
                      {{ c.accountable.contact_number }}<br />
                      {{ c.accountable.email_address }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="c">
                    <div v-if="c.accountable">
                      {{ c.accountable.name }} {{ c.accountable.surname }}
                    </div>
                  </template>
                </v-select>

                <small v-if="$v.selectedAccount.$error" class="text-danger">
                  Please select tenant
                </small>
              </form-group>

              <form-group label="Discount">
                <input
                  min="0"
                  type="number"
                  class="form-control"
                  v-model="invoice.discount_amount"
                />
              </form-group>

              <form-group
                label="Select Lease"
                :required="true"
                v-if="leases.length > 0"
              >
                <b-form-select
                  v-model="invoice.property_lease_id"
                  :options="leases"
                  value-field="id"
                  text-field="display"
                ></b-form-select>
                <small
                  v-if="$v.invoice.property_lease_id.$error"
                  class="text-danger"
                >
                  Please select a lease
                </small>
              </form-group>

              <form-group label="Email to tenant">
                <b-form-checkbox
                  v-model="invoice.email_to_tenant"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0"
                  switch
                >
                  Send invoice to tenants email
                </b-form-checkbox>
              </form-group>

              <form-group label="Items" :required="true">
                <table class="table table-bordered" v-if="lines.length>0">
                  <tr class="font-weight-bold">
                    <td>Description</td>
                    <td>Qty</td>
                    <td>Amount</td>
                    <td>Total</td>
                    <td></td>
                  </tr>
                  <tr v-for="line in lines" :key="line.id">
                    <td>
                      {{ line.description }}
                    </td>
                    <td>
                      {{ line.quantity }}
                    </td>
                    <td>
                      {{ line.line_amount }}
                    </td>
                     <td>
                      {{ line.line_amount * line.quantity }}
                    </td>
                    <td>
                      <i
                        class="lni lni-trash text-danger pointer"
                        @click="deleteLine(line)"
                      ></i>
                    </td>
                  </tr>
                  <tr v-if="lines.length>0">
                    <td colspan="3"><h3>Total</h3></td>
                    <td  colspan="2">
                     <h3> {{ getInvoiceTotal() }}</h3>
                    </td>
                  </tr>
                </table>

                <div class="border bg-light p-3 my-3" v-if="leases.length>0">
                  <small class="mb-5">Add the invoice line items</small>

                  <form-group label="Description" :required="true">
                    <input
                      ref="description"
                      class="form-control"
                      type="text"
                      v-model="description"
                    />
                  </form-group>

                  <form-group label="Quantity" :required="true">
                    <b-form-spinbutton
                      class="form-control"
                      type="number"
                      min="1"
                      v-model="quantity"
                    />
                  </form-group>

                  <form-group label="Amount" :required="true">
                    <input
                      class="form-control"
                      type="number"
                      min="0"
                      v-model="amount"
                    />
                  </form-group>

                  <div style="clear:both;" class="pb-5">

                  <b-button
                    variant="info"
                    class="btn-sm float-right text-white"
                    @click="addLine"
                    >Add Line</b-button
                  >

                  </div>
                
                </div>
              </form-group>
            </template>
          </form-base>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import FormGroup from "../../../components/common/FormGroup.vue";

export default {
  props: ["accountId"],

  components: {
    formBase,
    formGroup,
    FormGroup,
  },

  validations: {
    selectedAccount: {
      required,
    },
    invoice: {
      property_lease_id: {
        required,
      },
    },
  },

  mounted() {
    if (this.accountId) {
      this.accountSearch(this.accountId);
    }
  },

  data() {
    return {
      description: null,
      quantity: 1,
      amount: null,
      accounts: [],
      lines: [],
      leases: [],
      selectedAccount: {},
      searchActivated: false,
      paymentTypes: [],
      invoice: {
        email_to_tenant: 1,
      },
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    getAccounts(search) {
      this.searchActivated = true;
      if (search.length > 1) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.accountSearch(search);
        }, 500);
      }
    },

    async accountSearch(search) {
      try {
        let { data } = await accountRepo.accounts(
          1,
          25,
          "id",
          "asc",
          search,
          null
        );
        this.accounts = data.accounts.data;
        if (this.accountId && !this.searchActivated) {
          this.accounts.forEach((a) => {
            if (a.id == this.accountId) {
              this.selectedAccount = a;
            }
          });
        }
      } finally {
        this.loading = false;
      }
    },

    async handleSubmit() {
      if (this.lines.length == 0) {
        this.$root.$bvToast.toast("No Lines", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      this.loading = true;
      this.submitStatus = "PENDING";

      this.invoice.account_id = this.selectedAccount.id;
      this.invoice.tenant_id = this.selectedAccount.accountable_id;
      this.invoice.lines = this.lines;
      this.leases.forEach((x) => {
        if (x.id == this.invoice.property_lease_id) {
          this.invoice.property_id = x.property_id;
        }
      });

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await accountRepo.invoiceCreate(this.invoice);

          this.$root.$bvToast.toast("Success", {
            title: "Invoice Created",
            autoHideDelay: 3000,
            variant: "success",
          });
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.$router.push({ name: "accounts-invoices" });
        }
      }
    },

    async getLeases() {
      this.loading = true;
      try {
        let { data } = await accountRepo.leases(this.selectedAccount.id);
        this.leases = data.leases;
        this.leases.forEach((x) => {
          x.display =
            x.status +
            " - " +
            x.property.title +
            "(" +
            x.from +
            " -> " +
            x.to +
            ")";
        });
      } catch {
        this.$root.$bvToast.toast("Form Errors", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
      } finally {
        this.loading = false;
      }
    },

    addLine() {
      if (
        this.quantity == null ||
        this.amount == null ||
        this.description == null
      ) {
        this.$root.$bvToast.toast("Form Errors", {
          title: "Quantity,Description,Amount required",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      this.lines.push({
        code: "FF",
        quantity: this.quantity,
        line_amount: this.amount,
        description: this.description,
      });

      this.description = null;
      this.quantity = 1;
      this.amount = null;
      this.$refs.description.focus();
    },

    getInvoiceTotal(){
      let total = 0
      this.lines.forEach((x) => {
        total += (x.quantity*x.line_amount)
      });
      return total
    },

    deleteLine(line) {
      this.lines = this.lines.filter((x) => {
        return x != line;
      });
    },
  },

  watch: {
    selectedAccount: function (val) {
      if (val) {
        this.getLeases();
      }
    },
  },
};
</script>

<style></style>
